import styled from 'styled-components';

export const AgencyChartWrapper = styled.div`
  padding-left: 5.063rem;
  padding-right: 3rem;
`;
export const ChartSizeWrapper = styled.div`
  width: 68.563rem;
  height: 28.563rem;
  margin-top: 3.75rem;
`;
export const FilterTopPageWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const PrepaidUsageAgency = styled.div`
  position: absolute;
  margin-top: -2rem;
  margin-left: 0rem;
  color: #868686;
  font-size: 0.75rem;
`;